(() => {
  const init = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const email = root.querySelector('.birdega-clubhouse__input');
    const emailError = root.querySelector('[data-clubhouse-email-error]');

    if (email && emailError) {
      email.addEventListener('invalid', (event) => {
        event.preventDefault();
        emailError.hidden = false;
        email.setAttribute('aria-invalid', 'true');
        email.setAttribute('aria-describedby', emailError.id);
      });

      email.addEventListener('input', () => {
        if (email.validity.valid) {
          emailError.hidden = true;
          email.removeAttribute('aria-invalid');
          email.removeAttribute('aria-describedby');
        }
      });
    }

    const preferences = root.querySelector('[data-clubhouse-preferences]');
    if (!preferences) return;

    const tags = preferences.querySelector('[data-clubhouse-tags]');
    const save = preferences.querySelector('.birdega-clubhouse__save');
    const saved = preferences.querySelector('[data-clubhouse-saved]');

    preferences.addEventListener('submit', async (event) => {
      event.preventDefault();

      const location = preferences.querySelector('input[name="clubhouse-location"]:checked');
      const interest = preferences.querySelector('input[name="clubhouse-interest"]:checked');
      const values = ['newsletter', 'first-access', 'clubhouse'];
      if (location?.value) values.push(location.value);
      if (interest?.value) values.push(interest.value);
      tags.value = values.join(',');

      save.disabled = true;

      try {
        const response = await fetch(preferences.action, {
          method: 'POST',
          body: new FormData(preferences),
          headers: { Accept: 'text/html' }
        });

        if (!response.ok) throw new Error('Unable to save preferences');

        save.hidden = true;
        saved.hidden = false;
      } catch (error) {
        save.disabled = false;
        saved.textContent = 'PLEASE TRY AGAIN.';
        saved.hidden = false;
      }
    });
  };

  const boot = (scope = document) => scope.querySelectorAll('[data-birdega-clubhouse]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
